export const commonEnv = {
  assetBasePath: 'https://cdn.bayervirtualexperience.com/bayer/',
  showName: 'sv'
};
